define('models/merchants/merchantgroups/merchantgroup',['backbone'], function(Backbone){
    var MerchantGroup = Backbone.Model.extend({
        url: function(){
            if(!pf.session.get("auth")){
                return pf.merchantsURL + "/Discover/" + this.MerchantGroupGUID;
            } else {
                return pf.merchantsURL + "/Groups/" + this.MerchantGroupGUID + "/Info";
            }
        },
        initialize: function (options) {
            options || (options = {});
            this.MerchantGroupGUID = options.MGGD;
            this.GroupName = options.MGN;
            this.MerchantCount = options.MC;
            this.Logo = options.MGL;
            this.Photo = options.MGGD != null && options.MGP != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, options.MGGD, pf.enums.imageTypeGUIDEnum.Profile, options.MGP) : null;
            this.ShortDescription = options.SD;
            this.LongDescription = options.LD;
            this.Website = options.MGW;
            this.TotalRebates = options.TR;
            this.MinPercentage = options.MNP;
            this.MaxPercentage = options.MXP;
            this.HasDeal = options.HD;
            this.MerchantCategory = options.CAT;
            this.AffiliateURL = options.AURL;
            this.ExternalURL = options.EU;
            this.AffiliateURLMerchantGUID = options.AMGID;
            this.HasOnlineMerchants = options.HOM;
            this.HasInStoreMerchants = options.HISM;
        },
        parse: function (data) {
            //_gaq.push(['_trackEvent', 'Consumer', 'Merchant', data.MGN + '-' + data.MGGD, null, null]);
            gAnalytics('Merchant', data.MGN + '-' + data.MGGD, '');

            var response = {};
            response.MerchantGroupGUID = data.MGGD;
            response.GroupName = data.MGN;
            response.MerchantCount = data.MC;            
            response.Logo = data.MGL != null && data.MGL != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGGD, pf.enums.imageTypeGUIDEnum.Profile, data.MGL) : null;
            response.Photo = data.MGGD != null && data.MGP != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGGD, pf.enums.imageTypeGUIDEnum.Profile, data.MGP) : null;
            response.ShortDescription = data.SD;
            response.Website = data.MGW;
            response.LongDescription = data.LD;
            response.TotalRebates = data.TR;
            response.MinPercentage = data.MNP;
            response.MaxPercentage = data.MXP;
            response.HasDeal = data.HD;
            response.MerchantCategory = data.CAT;
            response.AffiliateURL = data.AURL;
            response.ExternalURL = data.EU;
            response.AffiliateURLMerchantGUID = data.AMGID;
            response.HasOnlineMerchants = data.HOM;
            response.HasInStoreMerchants = data.HISM;
            return response;
        }
    });
    return MerchantGroup;
});
